import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';
import { getStripeTestModeEnabled } from '@views/Settings/panels/Staging/StripeTesting';

const backgroundColor = 'rgb(49,49,49)';

const stripeOptions: StripeElementsOptions = {
  // c'mon, typescript
  mode: 'setup' as 'setup',
  currency: 'usd',
  paymentMethodTypes: ['card', 'us_bank_account', 'link'],
  appearance: {
    // theme: 'night',
    variables: {
      fontFamily:
        '"SFProText", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      fontSizeBase: '12px',
      colorLogoBlock: 'dark',
      colorBackground: '#000',
      colorPrimary: '#2686be',
      colorLogo: 'dark',
      borderRadius: '6px',
      colorText: '#fff',
      colorIconCheckmark: '#fff',
    },
    rules: {
      '.Input': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
        paddingTop: '5px',
        paddingBottom: '5px',
      },
      '.Input:focus': {
        borderColor: 'rgba(255,255,255,0.2)',
        boxShadow: '0',
      },
      '.Tab': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
      },
      '.Block': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
      },
      '.PickerItem': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
      },
      '.PickerItem:hover': {
        backgroundColor: 'rgb(70,70,70)',
      },
      '.Label': {
        textTransform: 'uppercase',
        fontSize: '10px',
        letterSpacing: '1px',
        color: '#999',
      },
      '.Text--terms': {
        color: '#999',
        textAlign: 'center',
      },
      '.TermsText': {
        textAlign: 'center',
        display: 'none',
      },
      '.CheckboxInput': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
      },
      '.CheckboxInput--checked': {
        backgroundColor,
        borderColor: 'rgba(255,255,255,0.04)',
      },
    },
  },
};

const STRIPE_TEST_KEY = 'pk_test_snOTSQZ6XKitV4yTXy4Quv71';
const STRIPE_LIVE_KEY = 'pk_live_R5u8LjYyijiMjUmVrSYWBDb1';
const stripeTestMode = getStripeTestModeEnabled();

let stripePromise = undefined;
if (stripeTestMode) {
  stripePromise = loadStripe(STRIPE_TEST_KEY);
} else {
  stripePromise = loadStripe(STRIPE_LIVE_KEY);
}

export default function StripeProvider({ children }: { children: React.ReactNode }) {
  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      {children}
    </Elements>
  );
}
